<template>
  <div>
    <NavPage></NavPage>
    <div class="content">
      <div>
        <SlideShow></SlideShow>
      </div>
      <div v-for="(solutionItem, index) in solutionOptions" :key="index + 'projectCase'" style="box-sizing: border-box; margin: auto;width:78%; padding:0 1%;">
        <pageContent :solutionItem="solutionItem" pageType="home"/>
      </div>

      <FooterPage></FooterPage>
    </div>
  </div>
</template>

<script>
import NavPage from "@/components/NavPage.vue";
import SlideShow from "@/components/SlideShow.vue";
import FooterPage from "@/components/FooterPage.vue";
import pageContent from "@/components/pageContent.vue";
import { solutionOptions } from '@/view/solution.js'

export default {
  name: "HomePage",
  components: {
    NavPage,
    SlideShow,
    FooterPage,
    pageContent
  },
  data() {
    return {
      solutionOptions
    }
  },
  methods: {
    getInfo(val) {
      var rowData = val;
      sessionStorage.setItem("rowData", JSON.stringify(rowData));
      this.$router.push({
        name: "BuildingControl"
      });
    }
  }
};
</script>


<style scoped>
.content {
 width: 1340px;
  margin: auto;
}

</style>